module.exports = __webpack_public_path__ + "img/blogs_dollar_green.f32d080b.png";